import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";

const useModulePermission = ({ id }) => {
  const { authData } = useSelector((state) => state.loginSlice);
  const [moduleData, setModuleData] = useState(null);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const getModuleById = async () => {
    try {
      setLoader(true);
      const response = await apiHandler({
        url: `${endpoint.GET_MODULE_BY_ID}/${id}`,
        method: "GET",
        authToken: authData,
        dispatch,
      });
      if (response.data.success) {
        setModuleData(response.data.data);
      }
    } catch (error) {
  
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      getModuleById();
    }
  }, []);
  return { moduleData, loader };
};

export default useModulePermission;
